<template>
  <div>
    <b-button variant="success" @click="showModal('modal-createshiftswithtemplate')">Schichten nach Template anlegen</b-button>
                        

    <b-modal ref="modal-createshiftswithtemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Schichten nach Template anlegen" @cancel="hideModal('modal-createshiftswithtemplate')" @ok="openShiftTemplateGroupModal" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Template Gruppe" label-for="cswt1">
                    <b-form-select id = "css1" v-model="shiftTemplateGroupId">
                         <option v-for="option in shiftTemplateGroupMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name+': '+businessunitMap[option.unitId].name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum von" label-for="cswt2">
                    <b-form-input id="cswt2" v-model="templateCreationStartDate" type="date"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Datum bis" label-for="cswt3">
                    <b-form-input id="cswt3" v-model="templateCreationEndDate" type="date"></b-form-input>
                </b-form-group>

               
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Schichten.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewshifttemplategroup"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Schicht Vorlage Detail" @cancel="hideModal('modal-viewshifttemplategroup')" @ok="createShiftsWithTemplate" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Schicht Template">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createshifttemplate')">Schicht Template hinzufügen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="shiftTemplates!= undefined">
                        <b-table bordered :items="shiftTemplates" :fields="shiftTemplateFields">
                        <template slot="actions" slot-scope="row">
                            <b-button class="mx-1" size="sm" v-on:click="openShiftTemplateViewModal(row.item.id)"><i class="fas fa-eye"></i></b-button>
                            <b-button class="mx-1" size="sm" v-on:click="openShiftTemplateEditModal(row.item.id)"><i class="fas fa-pencil-alt"></i></b-button>
                            <b-button class="mx-1" size="sm" variant="danger" v-on:click="deleteShiftTemplate(row.item.id)"><i class="fas fa-trash"></i></b-button>
                        </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-viewshifttemplate"  size="xl" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Schicht Detail" @cancel="hideModal('modal-viewshifttemplate')" @ok="hideModal('modal-viewshifttemplate')" cancel-title="Abbrechen">
        <b-container fluid>
         <b-card no-body>
            <b-tabs card>
                <b-tab title="Vorlage" active>
                    <div v-if="shiftTemplateMap[shiftTemplateId] != undefined">
                        <b-row>
                            <b-col class="md-2">
                                <b>Position:</b> 
                            </b-col>
                            <b-col>
                                <p v-if="!$helpers.isBlank(shiftTemplateMap[shiftTemplateId].spotId)">{{spotMap[shiftTemplateMap[shiftTemplateId].spotId].name}}</p>
                            </b-col>
                            <b-col class="md-2">
                                <b>Event:</b> 
                            </b-col>
                            <b-col>
                                <p v-if="!$helpers.isBlank(storeEventMap[shiftTemplateId].eventId)">{{storeEventMap[shiftTemplateMap[shiftTemplateId].eventId].name}}</p>
                            </b-col>
                        </b-row>
                        <b-row>
                            
                            <b-col class="md-2">
                                <b>Wochentage:</b> 
                            </b-col>
                            <b-col>
                                <p >{{shiftTemplateMap[shiftTemplateId].weekDays}} </P>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Von:</b> 
                            </b-col>
                            <b-col>
                                {{shiftTemplateMap[shiftTemplateId].from}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Bis:</b> 
                            </b-col>
                            <b-col>
                                {{shiftTemplateMap[shiftTemplateId].to}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Arbeitszeit-Wert:</b> 
                            </b-col>
                            <b-col>
                                {{shiftTemplateMap[shiftTemplateId].workValue}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Feiertags Arbeitszeit-Wert:</b> 
                            </b-col>
                            <b-col>
                                {{shiftTemplateMap[shiftTemplateId].holidayWorkValue}}
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col class="md-2">
                                <b>Anzahl:</b> 
                            </b-col>
                            <b-col>
                                {{shiftTemplateMap[shiftTemplateId].count}}
                            </b-col>
                            <b-col class="md-2">
                                <b>Beschreibung:</b> 
                            </b-col>
                            <b-col>
                                {{shiftTemplateMap[shiftTemplateId].description}}
                            </b-col>
                        </b-row>
                    </div>
                </b-tab>
                <b-tab title="Skills">
                    <b-row class="my-1">
                        <b-col>
                            <b-button variant="success" @click="showModal('modal-createshifttemplateskill')">Skill hinzufügen</b-button>
                        </b-col>
                    </b-row>
                    <div v-if="shiftTemplateSkills!= undefined">
                        <b-table bordered :items="shiftTemplateSkills" :fields="shiftTemplateSkillFields">
                            <template slot="min" slot-scope="row">
                                <p v-if="row.item.required">{{row.item.minValue}} </p>
                                <p v-else>-</p>
                            </template>
                            <template slot="max" slot-scope="row">
                                <p v-if="row.item.required">{{row.item.maxValue}} </p>
                                <p v-else>-</p>
                            </template>
                            <template slot="actions" slot-scope="row">
                                <b-button class="mx-1" size="sm" variant="danger" v-on:click="deleteShiftTemplateSkill(row.item.id)"><i class="fas fa-trash"></i></b-button>
                            </template>
                        
                        </b-table>
                    </div>
                    
                </b-tab>
               

            </b-tabs>
        </b-card>   
        </b-container>
    </b-modal>

    <b-modal ref="modal-createshifttemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Schicht anlegen" @cancel="hideModal('modal-createshifttemplate')" @ok="createShiftTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Position" label-for="cst1">
                    <b-form-select id = "cst1" v-model="shiftTemplate.spotId">
                        <option v-bind:value="null">
                            Keine Position
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Position" label-for="cst1">
                    <b-form-select id = "cst1" v-model="shiftTemplate.eventId">
                        <option v-bind:value="null">
                            Kein Event
                        </option>
                         <option v-for="option in storeEventMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="cst2">
                    <b-form-input id="cst2" v-model="shiftTemplate.from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="cst3">
                    <b-form-input id="cst3" v-model="shiftTemplate.to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Montag" label-for="mondaycheck">
                     <b-form-checkbox id="mondaycheck" v-model="shiftTemplate.monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Dienstag" label-for="tuesdaycheck">
                     <b-form-checkbox id="tuesdaycheck" v-model="shiftTemplate.tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mittwoch" label-for="wednesdaycheck">
                     <b-form-checkbox id="wednesdaycheck" v-model="shiftTemplate.wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Donnerstag" label-for="thursdaycheck">
                     <b-form-checkbox id="thursdaycheck" v-model="shiftTemplate.thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freitag" label-for="fridaycheck">
                     <b-form-checkbox id="fridaycheck" v-model="shiftTemplate.friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Samstag" label-for="saturdaycheck">
                     <b-form-checkbox id="saturdaycheck" v-model="shiftTemplate.saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Sonntag" label-for="sundaycheck">
                     <b-form-checkbox id="sundaycheck" v-model="shiftTemplate.sunday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Anzahl" label-for="cst6">
                    <b-form-input id="cst6" v-model.number="shiftTemplate.count" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Autom. Arbeitszeit" label-for="cst7">
                    <b-form-checkbox id="cst7" v-model="shiftTemplate.calculateWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Zeitwert (Minuten)" label-for="cst8" v-if="shiftTemplate.calculateWorkValue === false">
                    <b-form-input min="-1" id="cst8" v-model.number="shiftTemplate.workValue" type="number"></b-form-input>
                </b-form-group>

                 <b-form-group label-cols="4" label-cols-lg="4" label="Autom. Feiertags Arbeitszeit" label-for="cst9">
                    <b-form-checkbox id="cst9" v-model="shiftTemplate.calculateHolidayWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Feiertags Zeitwert (Minuten)" label-for="cst10" v-if="shiftTemplate.calculateHolidayWorkValue === false">
                    <b-form-input min="-1" id="cst10" v-model.number="shiftTemplate.holidayWorkValue" type="number"></b-form-input>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Beschreibung" label-for="cst11">
                    <b-form-input id="cst11" v-model="shiftTemplate.description" type="text"></b-form-input>
                </b-form-group>
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen der Muster Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-editshifttemplate"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Schicht bearbeiten" @cancel="hideModal('modal-editshifttemplate')" @ok="updateShiftTemplate" cancel-title="Abbrechen">
        <b-container fluid>
            <div v-if="editTemplate!=undefined">
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Position" label-for="ust1">
                    <b-form-select id = "ust1" v-model="editTemplate.spotId">
                        <option v-bind:value="null">
                            Keine Position
                        </option>
                         <option v-for="option in spotMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Event" label-for="ust1">
                    <b-form-select id = "ust1" v-model="editTemplate.eventId">
                        <option v-bind:value="null">
                            Kein Event
                        </option>
                         <option v-for="option in storeEventMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit von" label-for="ust2">
                    <b-form-input id="ust2" v-model="editTemplate.from" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Uhrzeit bis" label-for="cst3">
                    <b-form-input id="ust3" v-model="editTemplate.to" type="time"></b-form-input>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Montag" label-for="umondaycheck">
                     <b-form-checkbox id="umondaycheck" v-model="editTemplate.monday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Dienstag" label-for="utuesdaycheck">
                     <b-form-checkbox id="utuesdaycheck" v-model="editTemplate.tuesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Mittwoch" label-for="uwednesdaycheck">
                     <b-form-checkbox id="uwednesdaycheck" v-model="editTemplate.wednesday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Donnerstag" label-for="uthursdaycheck">
                     <b-form-checkbox id="uthursdaycheck" v-model="editTemplate.thursday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Freitag" label-for="ufridaycheck">
                     <b-form-checkbox id="ufridaycheck" v-model="editTemplate.friday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Samstag" label-for="usaturdaycheck">
                     <b-form-checkbox id="usaturdaycheck" v-model="editTemplate.saturday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Sonntag" label-for="usundaycheck">
                     <b-form-checkbox id="usundaycheck" v-model="editTemplate.sunday">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Anzahl" label-for="ust6">
                    <b-form-input id="ust6" v-model.number="editTemplate.count" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Autom. Arbeitszeit" label-for="ust7">
                    <b-form-checkbox id="ust7" v-model="editTemplate.calculateWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Zeitwert (Minuten)" label-for="ust8" v-if="editTemplate.calculateWorkValue === false">
                    <b-form-input min="-1" id="ust8" v-model.number="editTemplate.workValue" type="number"></b-form-input>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Autom. Feiertags Arbeitszeit" label-for="ust9">
                    <b-form-checkbox id="ust9" v-model="editTemplate.calculateHolidayWorkValue">
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Feiertags Zeitwert (Minuten)" label-for="ust10" v-if="editTemplate.calculateHolidayWorkValue === false">
                    <b-form-input min="-1" id="ust10" v-model.number="editTemplate.holidayWorkValue" type="number"></b-form-input>
                </b-form-group>

                 <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Beschreibung" label-for="ust9">
                    <b-form-input id="ust11" v-model="editTemplate.description" type="text"></b-form-input>
                </b-form-group>

                

                 
            </div>
            
            <b-row v-if="error">
                Fehler beim Update der Muster Schicht.
            </b-row>
        </b-container>
    </b-modal>

    <b-modal ref="modal-createshifttemplateskill"  size="lg" scrollable no-close-on-backdrop no-close-on-esc centered title="Muster Schicht Skill anlegen" @cancel="hideModal('modal-createshifttemplateskill')" @ok="createShiftTemplateSkill" cancel-title="Abbrechen">
        <b-container fluid>
            <div>
            
                <b-form-group label-cols="4" label-cols-lg="4" label="Skill" label-for="css1">
                    <b-form-select id = "css1" v-model="shiftTemplateSkill.skillId">
                         <option v-for="option in skillMap" v-bind:key ="option.id" v-bind:value="option.id">
                            {{ option.name }}
                        </option>
                    </b-form-select>
                </b-form-group>

                <b-form-group label-cols="4" label-cols-lg="4" label="Verpflichtend" label-for="css2">
                    <b-form-checkbox id="css2" v-model="shiftTemplateSkill.required">
                    </b-form-checkbox>
                </b-form-group>

                <section v-if="shiftTemplateSkill.required">
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Min. Skill Wert" label-for="ctfield16" :description="''+shiftTemplateSkill.minValue">
                            <b-form-input min="1" :max="shiftTemplateSkill.maxValue" id="ctfield16" v-model.number="shiftTemplateSkill.minValue" type="range"></b-form-input>
                    </b-form-group>
                    <b-form-group label-text-align="left" label-cols="4" label-cols-lg="4" label="Max. Skill Wert" label-for="ctfield17" :description="''+shiftTemplateSkill.maxValue">
                            <b-form-input  :min="shiftTemplateSkill.minValue" max="100" id="ctfield17" v-model.number="shiftTemplateSkill.maxValue" type="range"></b-form-input>
                    </b-form-group>
                </section>

               
            </div>
            
            <b-row v-if="error">
                Fehler beim Erstellen des  Schicht Skills.
            </b-row>
        </b-container>
    </b-modal>

    
</div>

</template>

<script>
var moment = require('moment');
export default {
  name: 'shiftcreationwithtemplate',
  data () {
    return {
      dayIndexStartPerMonth: [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335],
      daysPerMonth: [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],

      yearDayMonth: 0,
      yearDayDay: 1,
      storeEventMap: {},
      businessunitMap: {},
      spotMap: {},
      skillMap: {},
      shiftTemplateGroupMap: {},
      shiftTemplateGroupId: null,
      templateCreationStartDate: null,
      templateCreationEndDate: null,
      shiftTemplateMap: {},
      shiftTemplates: [],
      shiftTemplateSkillMap:{},
      shiftTemplateSkills: [],
      shiftTemplateDayMap:{},
      shiftTemplateDays: [],
      shiftTemplateFields: [{key:"spot", label:"Position", sortable: true}, {key: "event", label: "Event", sortable: false}, 
                            {key:"from", label:"Von", sortable: true},{key:"to", label:"Bis", sortable: true},
                            {key:"weekDays", label:"Wochentage", sortable: false}, , {key:"count", label:"Anzahl", sortable: true}, {key:"actions", sortable: false}],
      shiftTemplateSkillFields: [{key:"skill", label:"Skill", sortable: true},{key:"required", label:"Verpflichtend", sortable: true},{key:"min", label:"Min. Wert", sortable: true}, {key:"max", label:"Max. Wert", sortable: true}, {key:"actions", sortable: false}],
      shiftTemplateId: "",
      editTemplate : {
          spotId: null,
          eventId: null,
          from: null,
          to: null,
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          count: 1,
          workValue: -1,
          holidayWorkValue: -1,
          calculateWorkValue: true,
          calculateHolidayWorkValue: true,
          description: ""
          
      },
      shiftTemplate: {
          spotId: null,
          eventId: null,
          from: null,
          to: null,
          monday: false,
          tuesday: false,
          wednesday:false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
          count: 1,
          workValue: -1,
          holidayWorkValue: -1,
          calculateWorkValue: true,
          calculateHolidayWorkValue: true,
          description: ""
          
      },
      shiftTemplateSkill: {
          skillId: null,
          required: false,
          minValue: 1,
          maxValue: 100,
      },
      shiftTemplateDay: {
          day: 1,
          month: 1,
      },
      error: false,
      
    }
  },
  created: function () {
    if(this.$store.state.jwt != undefined && this.$store.state.storeId != undefined){
         this.refresh();
    }
  },
  // methods that implement data logic.
  methods: {
    refresh: function(){
        let view = this;
        
        this.loadBusinessUnits()
        .then(response => {
            view.updateBusinessUnits(response.data);
            return this.loadSpots();
        }).then(response => {
            view.updateSpots(response.data);
            return this.loadSkills();
        }).then(response => {
            view.updateSkills(response.data);
            return this.loadStoreEvents();
        }).then(response => {
            view.updateStoreEvents(response.data);
            return this.loadShiftTemplateGroups();
        }).then(response => {
            view.updateShiftTemplateGroups(response.data);
        }).catch(function (error) {
            console.log(error)
        })
        

       
    }, 
    openShiftTemplateGroupModal: function() {
        let view = this;
        view.hideModal("modal-createshiftswithtemplate");
        this.loadShiftTemplates(this.shiftTemplateGroupId)
        .then(response => {
            let templateIds = [];
            for(let i = 0; i < response.data.length; i++){
                templateIds.push(response.data[i].id);
            }
            view.updateShiftTemplates(response.data);
            
            view.loadShiftTemplateSkills(templateIds)
            .then(response=> {
                view.updateShiftTemplateSkills(response.data);
                view.showModal("modal-viewshifttemplategroup");
                
            }).catch(function (error) {
                console.log(error)
            })
        }).catch(function (error) {
            view.error=true;
            console.log(error)
        })
    },
    openShiftTemplateViewModal: function(id){
        
        this.shiftTemplateId = id;
        let overviewA = [];
        for (let templateSkillId in this.shiftTemplateSkillMap) {
            let shiftTemplateSkill = this.shiftTemplateSkillMap[templateSkillId];
            if(shiftTemplateSkill.templateId === this.shiftTemplateId){
                let shiftTemplateSkillItem ={
                    id: shiftTemplateSkill.id,
                    required: shiftTemplateSkill.required,
                    skill: this.skillMap[shiftTemplateSkill.skillId].name,
                    minValue: shiftTemplateSkill.minValue,
                    maxValue: shiftTemplateSkill.maxValue
                }
                overviewA.push(shiftTemplateSkillItem);
            } 
        }
        
        this.shiftTemplateSkills = overviewA;
        this.showModal('modal-viewshifttemplate');   
        
    },
    openShiftTemplateEditModal: function(id){
        
        this.shiftTemplateId = id;
        let template = this.shiftTemplateMap[this.shiftTemplateId];
        this.editTemplate.spotId = template.spotId;
        this.editTemplate.eventId = template.eventId;
        this.editTemplate.updateShifts = false;
       
        
        if(!this.$helpers.isBlank(template.workValue)){
            if(template.workValue === -1){
                this.editTemplate.calculateWorkValue = true;
            } else {
                this.editTemplate.calculateWorkValue = false;
            }
            this.editTemplate.workValue = template.workValue;
        }

        if(!this.$helpers.isBlank(template.holidayWorkValue)){
            if(template.holidayWorkValue === -1){
                this.editTemplate.calculateHolidayWorkValue = true;
            } else {
                this.editTemplate.calculateHolidayWorkValue = false;
            }
            this.editTemplate.holidayWorkValue = template.holidayWorkValue;
        }

        this.editTemplate.from = this.$helpers.extractTimeString(template.from);
        
        this.editTemplate.to = this.$helpers.extractTimeString(template.to);
        
        this.editTemplate.count = template.count;

        this.editTemplate.description = template.description;

        if(template.weekDays.includes(1)){
            this.editTemplate.monday = true;
        }
        if(template.weekDays.includes(2)){
            this.editTemplate.tuesday = true;
        }
        if(template.weekDays.includes(3)){
            this.editTemplate.wednesday = true;
        }
        if(template.weekDays.includes(4)){
            this.editTemplate.thursday = true;
        }
        if(template.weekDays.includes(5)){
            this.editTemplate.friday = true;
        }
        if(template.weekDays.includes(6)){
            this.editTemplate.saturday = true;
        }
        if(template.weekDays.includes(7)){
            this.editTemplate.sunday = true;
        }

       
        

        
        this.showModal('modal-editshifttemplate');
    },
    createShiftTemplate: function(evt){
        
        let template = {
          id: this.generateUUID(),
          groupId: this.shiftTemplateGroupId,
          from: this.shiftTemplate.from,
          to: this.shiftTemplate.to,
          count: this.shiftTemplate.count,
          description: this.shiftTemplate.description,
          skillMultiplier: 1,
          workValueMultiplier:1,
          weekDays: [],
        }
        if(this.shiftTemplate.monday){
            template.weekDays.push(1);
        }
        if(this.shiftTemplate.tuesday){
            template.weekDays.push(2);
        }
        if(this.shiftTemplate.wednesday){
            template.weekDays.push(3);
        }
        if(this.shiftTemplate.thursday){
            template.weekDays.push(4);
        }
        if(this.shiftTemplate.friday){
            template.weekDays.push(5);
        }
        if(this.shiftTemplate.saturday){
            template.weekDays.push(6);
        }
        if(this.shiftTemplate.sunday){
            template.weekDays.push(7);
        }
       
        if(!this.$helpers.isBlank(this.shiftTemplate.spotId)){
            template.spotId = this.shiftTemplate.spotId
        }
        if(this.shiftTemplate.calculateWorkValue){
            template.workValue = -1;
        } else {
            template.workValue = this.shiftTemplate.workValue;
        }
        if(this.shiftTemplate.calculateHolidayWorkValue){
            template.holidayWorkValue = -1;
        } else {
            template.holidayWorkValue = this.shiftTemplate.holidayWorkValue;
        }

        let shiftTemplateItem = {
            id: template.id,
            from: template.from,
            to: template.to,
            count: template.count,
            weekDays: template.weekDays,
        }
            
        if(!this.$helpers.isBlank(template.spotId)){
            shiftTemplateItem.spot = this.spotMap[template.spotId].name;
        } else {
            shiftTemplateItem.spot = "";
        }
        if(!this.$helpers.isBlank(template.eventId)){
            shiftTemplateItem.event = this.storeEventMap[template.eventId].name;
        } else {
            shiftTemplateItem.event = "";
        }
        this.shiftTemplateMap[template.id] = template;
        this.shiftTemplates.push(shiftTemplateItem); 
        this.resetShiftTemplateValues();
    },
    createShiftTemplateSkill: function(evt){
       
        let templateSkill = {
            id: this.generateUUID(),
            templateId: this.shiftTemplateId,
            skillId: this.shiftTemplateSkill.skillId,
            required: this.shiftTemplateSkill.required,
            minValue: this.shiftTemplateSkill.minValue,
            maxValue: this.shiftTemplateSkill.maxValue,
        }

        let templateSkillItem = {
            id: templateSkill.id,
            required: templateSkill.required,
            skill: this.skillMap[templateSkill.skillId].name,
            minValue: templateSkill.minValue,
            maxValue: templateSkill.maxValue,
        }
        
        this.shiftTemplateSkillMap[templateSkill.id] = templateSkill;
        //add the skill id to shifttemplate
        if(this.shiftTemplateMap[this.shiftTemplateId] != undefined){
            if(this.shiftTemplateMap[this.shiftTemplateId].requiredSkills == undefined){
                this.shiftTemplateMap[this.shiftTemplateId].requiredSkills = []
            }
            this.shiftTemplateMap[this.shiftTemplateId].requiredSkills.push(templateSkill.id);
        }
        this.shiftTemplateSkills.push(templateSkillItem); 
    },
    
    updateShiftTemplate: function(evt){
        

        let template = this.shiftTemplateMap[this.shiftTemplateId];
        template.weekDays = [];
        if(this.editTemplate.monday){
            template.weekDays.push(1);
        }
        if(this.editTemplate.tuesday){
           template.weekDays.push(2);
        }
        if(this.editTemplate.wednesday){
            template.weekDays.push(3);
        }
        if(this.editTemplate.thursday){
            template.weekDays.push(4);
        }
        if(this.editTemplate.friday){
            template.weekDays.push(5);
        }
        if(this.editTemplate.saturday){
           template.weekDays.push(6);
        }
        if(this.editTemplate.sunday){
            template.weekDays.push(7);
        }
        template.eventId = this.editTemplate.eventId;
        template.spotid = this.editTemplate.spotId;
        template.from = this.$helpers.convertDateTimeString(null, this.editTemplate.from);
        template.to = this.$helpers.convertDateTimeString(null, this.editTemplate.to);
       
        template.count = this.editTemplate.count;
        template.description = this.editTemplate.description;
        template.skillMultiplier = this.editTemplate.skillMultiplier;
        template.workValueMultiplier = this.editTemplate.workValueMultiplier;
        

        if(this.editTemplate.calculateWorkValue){
            template.workValue = -1;
        } else {
            template.workvalue = this.editTemplate.workValue;
        }
        if(this.editTemplate.calculateHolidayWorkValue){
            template.holidayWorkValue = -1;
        } else {
            template.holidayWorkValue = this.editTemplate.holidayWorkValue;
        }

        const index = this.shiftTemplates.findIndex(shifttemplate => shifttemplate.id === template.id) 
        if (~index) {
            this.shiftTemplates[index].from = template.from;
            this.shiftTemplates[index].to = template.to;
           
            this.shiftTemplates[index].count = template.count;
            this.shiftTemplates[index].weekDays = template.weekDays;
            if(!this.$helpers.isBlank(template.spotId)){
                this.shiftTemplates[index].spot = this.spotMap[template.spotId].name;
            } else {
                this.shiftTemplates[index].spot = "";
            }
            if(!this.$helpers.isBlank(template.eventId)){
                this.shiftTemplates[index].event = this.storeEventMap[template.eventId].name;
            } else {
                this.shiftTemplates[index].event = "";
            }
        }

       this.resetShiftTemplateValues();
    },
    convertDayOfYearToDate(dayOfYear){
        let date = new Date(2016, 0, dayOfYear); //2016 because leap year
        
        return date.getDate()+"."+(date.getMonth()+1)+".";
    },
    createShiftsWithTemplate: function() {
        let view = this;
        let dayMap = {};
        let day;

        for(let templateId in this.shiftTemplateMap){

            let template = this.shiftTemplateMap[templateId];
            
            for(let j = 0; j< template.weekDays.length; j++){
                day = template.weekDays[j];
                
                if(dayMap[day] === undefined){
                       dayMap[day] = [];
                }
                dayMap[day].push(template.id);
             }
        }

        let startDate = this.$helpers.getMomentFromStringUTC(this.templateCreationStartDate).hours(0).minutes(0).seconds(0).milliseconds(0);
        let endDate = this.$helpers.getMomentFromStringUTC(this.templateCreationEndDate).add(1,'days').hours(0).minutes(0).seconds(0).milliseconds(0);
        //FILTERS AHEAD YO
        let shiftRequests = [];
        let template;
        let regularTemplates = Object.entries(this.shiftTemplateMap).filter(t => t[1].eventId == null).map(t => t[1]);
        let eventTemplates = Object.entries(this.shiftTemplateMap).filter(t => t[1].eventId != null).map(t => t[1]); 
        while(endDate.diff(startDate,'minutes') > 0){
            let dayStart = startDate.clone().hours(0).minutes(0).seconds(0).milliseconds(0);
            let dayEnd = dayStart.clone().add(1,'days');
            //check if theres events overlapping the day
            let eventIds = Object.entries(this.storeEventMap).filter(e => e[1].toMoment.isAfter(dayStart) && e[1].fromMoment.isBefore(dayEnd)).map(e => e[1].id);
            let filteredEventTemplates = eventTemplates.filter(t => eventIds.includes(t.eventId));
            
            //if theres any templates for any overlapping events, only create shifts from those templates
            if(filteredEventTemplates.length > 0){
                filteredEventTemplates.filter(t => t.weekDays.includes(startDate.isoWeekday())).forEach(template => {
                    let from = this.$helpers.getMomentFromStringUTC(template.from, 'HH:mmZ').year(startDate.year()).month(startDate.month()).date(startDate.date());
                    let to = this.$helpers.getMomentFromStringUTC(template.to, 'HH:mmZ').year(startDate.year()).month(startDate.month()).date(startDate.date());
                    if(to.diff(from) <= 0){
                        to.add(24, 'hours')
                    }
                    from = from.format();
                    to = to.format();
                    for(let j = 0; j < template.count; j++){
                        let request = {
                            from: from,
                            to: to,
                            spotId: template.spotId,
                            historicFrom: from, 
                            historicTo: to,
                            historicSpotId: template.spotId,
                            workValue: template.workValue,
                            holidayWorkValue: template.holidayWorkValue,
                            workValueMultiplier: 1.0,
                            skillMultiplier: 1,
                            tasks: template.tasks,
                            templateId: template.id
                        }
                            
                        shiftRequests.push(request);
                    }
                });
            } else {
                //create shifts for any regular template whose weekDays includes the weekday of current startDate
                regularTemplates.filter(t => t.weekDays.includes(startDate.isoWeekday())).forEach(template => {
                   let from = this.$helpers.getMomentFromStringUTC(template.from, 'HH:mmZ').year(startDate.year()).month(startDate.month()).date(startDate.date());
                    let to = this.$helpers.getMomentFromStringUTC(template.to, 'HH:mmZ').year(startDate.year()).month(startDate.month()).date(startDate.date());
                    if(to.diff(from) <= 0){
                        to.add(24, 'hours')
                    }
                    from = from.format();
                    to = to.format();
                    for(let j = 0; j < template.count; j++){
                        let request = {
                            from: from,
                            to: to,
                            spotId: template.spotId,
                            historicFrom: from, 
                            historicTo: to,
                            historicSpotId: template.spotId,
                            workValue: template.workValue,
                            holidayWorkValue: template.holidayWorkValue,
                            workValueMultiplier: 1.0,
                            skillMultiplier: 1,
                            tasks: template.tasks,
                            templateId: template.id
                        }
                            
                        shiftRequests.push(request);
                    }
                })
            }
            startDate.add(1, 'days');    
        }
        if(shiftRequests.length > 0){
            let url = '/api/sec/planshift/multi';
            url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/planshift/multi');

            let payload = {
                requests: shiftRequests
            }
                
            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
            }).then(response => {

                //after we know which shifts were created we can create the skill requirements for them
                let shiftTemplateSkillRequests = [];
                for(let i = 0; i<response.data.data.length; i++){
                    
                    let shift = response.data.data[i];
                    //find the original template from the responses originalId field denoting array index of request
                    let template = view.shiftTemplateMap[shiftRequests[shift.originalIndex].templateId];
                    //iterate over requiredSkills array to generate skill requests
                    if(template.requiredSkills != undefined){
                        for(let j = 0; j < template.requiredSkills.length; j++){

                            let shiftTemplateSkill = view.shiftTemplateSkillMap[template.requiredSkills[j]];
                            let req = {
                                shiftId: shift.id,
                                skillId: shiftTemplateSkill.skillId,
                                required: shiftTemplateSkill.required,
                                minValue: shiftTemplateSkill.minValue,
                                maxValue: shiftTemplateSkill.maxValue,
                            }
                            shiftTemplateSkillRequests.push(req);
                        }
                    }
                   
                    
                }
                if(shiftTemplateSkillRequests.length > 0){
                    this.createShiftSkillsWithTemplate(shiftTemplateSkillRequests)
                    .then(response => {
                        view.error = false;
                        view.$emit("refreshShifts");
                        view.hideModal('modal-viewshifttemplategroup')
                    }).catch(function (error) {
                        
                        view.$emit("refreshShifts");
                        console.log(error)
                        view.hideModal('modal-viewshifttemplategroup')
                    })
                } else {
                    view.error = false;
                    view.$emit("refreshShifts");
                    view.hideModal('modal-viewshifttemplategroup')
                }

               
            }).catch(function (error) {
                view.error=true;
                console.log(error)
            })
        } else {
            view.hideModal('modal-viewshifttemplategroup')
        }
        
    },
    createShiftSkillsWithTemplate: function(requests){
        
        let url = '/api/sec/shiftskillrequirement/multi';
        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shiftskillrequirement/multi');

        let payload = {
                requests: requests
        }
                
        return  this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer "+this.$store.state.jwt
                },
                url: url,
                data: payload
        })
    },
    loadShiftTemplateGroups : function() {
     
        let url = '/api/sec/shifttemplategroup';

        url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplategroup');
 
        return this.axios({
            method: 'get',
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })
			
    },
    updateShiftTemplateGroups : function(data){
        let tshiftTemplateGroupMap = {};

        for (let i = 0; i < data.length; i++) {
            tshiftTemplateGroupMap[data[i].id] = data[i];     
        }
        this.shiftTemplateGroupMap = tshiftTemplateGroupMap;
    },
    loadShiftTemplates : function(id) {
      
      let url = '/api/sec/shifttemplate';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplate');
      url = this.$helpers.appendParam("groupId", id, url, '/api/sec/shifttemplate')

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadShiftTemplateSkills : function(ids) {
      
      let url = '/api/sec/shifttemplateskillrequirement/any/template';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/shifttemplateskillrequirement/any/template');
      url = this.$helpers.appendParam("templateId", this.shiftTemplateId, url, '/api/sec/shifttemplateskillrequirement/any/template')

      let payload = {
          ids: ids
      };
      return this.axios({
        method: 'post',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url,
        data: payload
      })
        
        
    },
    
    updateShiftTemplateSkills: function(data){
        
        let map = {};
        for (let i = 0; i < data.length; i++) {
            map[data[i].id] =data[i];
            if(this.shiftTemplateMap[data[i].templateId] != undefined){
                if(this.shiftTemplateMap[data[i].templateId].requiredSkills == undefined){
                    this.shiftTemplateMap[data[i].templateId].requiredSkills = []
                }
                this.shiftTemplateMap[data[i].templateId].requiredSkills.push(data[i].id);
            }
        }
        this.shiftTemplateSkillMap = map;
    },
    
    updateShiftTemplates : function(data){
        let overviewA = [];
        let map = {};
        var i;
        for (i = 0; i < data.length; i++) {
            data[i].from = this.$helpers.extractTimeString(data[i].from);
            data[i].to = this.$helpers.extractTimeString(data[i].to);
            map[data[i].id] = data[i]; 
            let shiftTemplateItem = {
                id: data[i].id,
                from: data[i].from,
                to: data[i].to,
                weekDays: data[i].weekDays,
                count: data[i].count
            }
            
            if(!this.$helpers.isBlank(data[i].spotId)){
                shiftTemplateItem.spot = this.spotMap[data[i].spotId].name;
            } else {
                shiftTemplateItem.spot = "";
            }
            if(!this.$helpers.isBlank(data[i].eventId)){
                shiftTemplateItem.event = this.storeEventMap[data[i].eventId].name;
            } else {
                shiftTemplateItem.event = "";
            }
            overviewA.push(shiftTemplateItem);
        }
        this.shiftTemplateMap = map;
        this.shiftTemplates = overviewA;
    },
    deleteShiftTemplate(id){
        for(let p in this.shiftTemplateSkillMap){
            if(this.shiftTemplateSkillMap[p].templateId === id){
                this.deleteShiftTemplateSkill(p);
            }
        }
        
        let index = this.shiftTemplates.findIndex(shifttemplate => shifttemplate.id === id) 
        if (~index) {
             this.shiftTemplates.splice(index, 1);
        }
        delete this.shiftTemplateMap[id]
    },
    deleteShiftTemplateSkill(id){
        let index = this.shiftTemplateSkills.findIndex(shifttemplateskill => shifttemplateskill.id === id) 
        if (~index) {
             this.shiftTemplateSkills.splice(index, 1);
        }
        let template = this.shiftTemplateMap[this.shiftTemplateSkillMap[id].templateId]
        if(template.requiredSkills != undefined){
            index = template.requiredSkills.findIndex(requiredSkillId => requiredSkillId === id);
            if (~index) {
                template.requiredSkills.splice(index, 1);
            }
        }
        delete this.shiftTemplateSkillMap[id]
    },
    loadBusinessUnits : function() {

        let url = '/api/sec/businessunit';

        let params = {
            storeId: this.$store.state.storeId,
        };


        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        })


    },
    updateBusinessUnits: function(data){
  
        let tbunits = {}
        for (let i = 0; i < data.length; i++) {
           
            tbunits[data[i].id] = data[i];
        }
        this.businessunitMap = tbunits;

    },
    loadSpots : function() {
      
      let url = '/api/sec/spot';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/spot');
      

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadSkills : function() {
      
      let url = '/api/sec/skill';

      url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/skill');
     

      return this.axios({
        method: 'get',
        headers: {
            'AUTHORIZATION': "bearer "+this.$store.state.jwt
        },
        url: url
      })
        
        
    },
    loadStoreEvents: function() {
        let url = '/api/sec/storeevent';
        let params = {
            storeId: this.$store.state.storeId,
            active: true,
        };
        return this.axios({
            method: 'get',
            params: params,
            headers: {
                'AUTHORIZATION': "bearer "+this.$store.state.jwt
            },
            url: url
        });
    },
    updateStoreEvents: function(data){
        let i;
        let tstoreevents = {}
        for (i = 0; i < data.length; i++) {
            let item = data[i];
            item.fromMoment = this.$helpers.getMomentFromStringUTC(item.from);
            item.toMoment = this.$helpers.getMomentFromStringUTC(item.to);
            tstoreevents[data[i].id] = item;
            
        }
        this.storeEventMap = tstoreevents;
    },
    updateSpots: function(data){
        var i;
        let tspots = {}
        for (i = 0; i < data.length; i++) { 
            tspots[data[i].id] =data[i];
        }
        this.spotMap = tspots;
    },
    updateEmployees: function(data){
        var i;
        let temployees = {}
        for (i = 0; i < data.length; i++) {
            temployees[data[i].id] =data[i];
        }
        this.employeeMap = temployees;
    },
    updateSkills: function(data){
        var i;
        let tskills = {}
        for (i = 0; i < data.length; i++) {
            tskills[data[i].id] =data[i];
        }
        this.skillMap = tskills;
    },
    getMinuteDiff: function(from, to) {
        var diff =(to.getTime() - from.getTime()) / 1000;
        diff /= 60;
        return Math.round(diff);
    },
    getMinuteDiffAbs: function(from, to) {
        var diff =(to.getTime() - from.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    },
    generateUUID: function(){
        //https://jcward.com/UUID.js
        let lut = []; for (var i=0; i<256; i++) { lut[i] = (i<16?'0':'')+(i).toString(16); }
        let d0 = Math.random()*0xffffffff|0;
        let d1 = Math.random()*0xffffffff|0;
        let d2 = Math.random()*0xffffffff|0;
        let d3 = Math.random()*0xffffffff|0;
            return lut[d0&0xff]+lut[d0>>8&0xff]+lut[d0>>16&0xff]+lut[d0>>24&0xff]+'-'+
            lut[d1&0xff]+lut[d1>>8&0xff]+'-'+lut[d1>>16&0x0f|0x40]+lut[d1>>24&0xff]+'-'+
            lut[d2&0x3f|0x80]+lut[d2>>8&0xff]+'-'+lut[d2>>16&0xff]+lut[d2>>24&0xff]+
            lut[d3&0xff]+lut[d3>>8&0xff]+lut[d3>>16&0xff]+lut[d3>>24&0xff];
    },
    resetShiftTemplateValues() {
        this.yearDayMonth= 0;
        this.yearDayDay= 1;
        this.shiftTemplateId = null;
        this.editTemplate = {
            spotId: null,
            eventId: null,
            from: null,
            to: null,
            monday: false,
            tuesday: false,
            wednesday:false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
            count: 1,
            workValue: -1,
            holidayWorkValue: -1,
            calculateWorkValue: true,
            calculateHolidayWorkValue: true,
            description: ""
          
        },
        this.shiftTemplate ={
            spotId: null,
            eventId: null,
            from: null,
            to: null,
            monday: false,
            tuesday: false,
            wednesday:false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
            count: 1,
            workValue: -1,
            holidayWorkValue: -1,
            calculateWorkValue: true,
            calculateHolidayWorkValue: true,
            description: ""
            
        };
    },
    resetShiftTemplateSkillValues(){
        this.shiftTemplateSkill = {
            skillId: null,
            required: false
        };
    },
    hideModal (ref) {
        this.resetShiftTemplateValues();
        this.resetShiftTemplateSkillValues();
        this.error = false;
        this.$refs[ref].hide()
    },
    showModal(ref) {
        this.$refs[ref].show()
    }
  },
  components: {
  },
  computed: {
   
  },
  watch: { 
   

    }

}
</script>

<!-- Add "scoped" attrispotte to limit CSS to this component only -->
<style scoped>

</style>
